export const debounce = (func, timeout = 300) => {
  let timer;
  function result() {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, arguments), timeout);
  }
  result.now = function() {
    func.apply(this, arguments);
  };
  return result;
};